// ICAP v. Chilena — ítems por sección
export const ICAP2_SECTIONS = [
  {
    title: "Destrezas Motoras (DM)",
    items: [
      { var: "dm_item1", label: "1. Pasa objetos pequeños de una mano a otra" },
      { var: "dm_item2", label: "2. Se sienta solo/a manteniendo la cabeza y la espalda derechas y firmes (sin apoyo) durante treinta segundos." },
      { var: "dm_item3", label: "3. Se mantiene de pie, al menos durante cinco segundos, apoyándose en muebles u otros objetos." },
      { var: "dm_item4", label: "4. Mete objetos pequeños en recipientes y los vuelva a sacar después." },
      { var: "dm_item5", label: "5. Hace rayas, marcas o dibujos, con lápiz o con pinturas, en una hoja de papel." },
      { var: "dm_item6", label: "6. Escribe su nombre copiándolo de un modelo." },
      { var: "dm_item7", label: "7. Levanta y lleva una bolsa con diferentes comestibles por lo menos a una distancia de seis metros y la deposita en el suelo." },
    ],
  },
  {
    title: "Destrezas Sociales y Comunicativas (DSC)",
    items: [
      { var: "dsc_item1", label: "1. En actividades grupales, espera por lo menos dos minutos a que le llegue su turno (por ejemplo, espera su turno para patear una pelota o tomar un trago de agua)." },
      { var: "dsc_item2", label: "2. Ofrece ayuda a otras personas (ejemplo: mantiene la puerta abierta para que pase una persona que tiene las manos ocupadas o recoge un objeto que se le ha caído a alguien)." },
      { var: "dsc_item3", label: "3. Se comporta de una manera adecuada, sin llamar la atención de los demás, cuando está con sus amigos en lugares públicos (por ejemplo: cine, micro, centro comercial, etc.)." },
      { var: "dsc_item4", label: "4. Cuenta de manera resumida una historia de forma que otra persona pueda entenderla (por ejemplo un programa de TV o una película del cine)." },
      { var: "dsc_item5", label: "5. Recuerda o sabe cómo localizar números telefónicos y llama a sus amigos." },
    ],
  },
  {
    title: "Destrezas de la Vida Personal (DVP)",
    items: [
      { var: "dvp_item1", label: "1. Traga alimentos blandos." },
      { var: "dvp_item2", label: "2. Permanece sin orinarse al menos durante tres horas." },
      { var: "dvp_item3", label: "3. Se quita el pantalón o la falda y la ropa interior." },
      { var: "dvp_item4", label: "4. Hace sus necesidades cuando se le sienta en WC de acuerdo a un horario regular o cuando se le lleva al baño." },
      { var: "dvp_item5", label: "5. Se pone camisetas o polerón, aunque sea al revés." },
    ],
  },
  {
    title: "Destrezas de la Vida Diaria (DVD)",
    items: [
      { var: "dvd_item1", label: "1. Lava, seca y luego guarda los platos en su lugar." },
      { var: "dvd_item2", label: "2. Arregla su dormitorio, lo cual incluye guardar su ropa, cambiar las sábanas, quitar el polvo y barrer el suelo." },
      { var: "dvd_item3", label: "3. Prepara listas de compras de por lo menos seis productos para adquirir en una tienda de comestibles." },
      { var: "dvd_item4", label: "4. Carga y maneja una lavadora, utilizando la cantidad de detergente y el programa apropiado." },
      { var: "dvd_item5", label: "5. Planifica, prepara y sirve una comida completa para más de dos personas." },
      { var: "dvd_item6", label: "6. Realiza pequeñas reparaciones de su ropa, como coserse un botón, o encarga a la persona adecuada para que lo haga." },
      { var: "dvd_item7", label: "7. Maneja herramientas manuales eléctricas, potencialmente peligrosas, y aparatos de piezas móviles (por ejemplo: un taladro eléctrico, una batidora o una licuadora)." },
      { var: "dvd_item8", label: "8. Administra su dinero de forma que cubra los gastos de, por lo menos, una semana (ocio, transporte y otras necesidades)." },
      { var: "dvd_item9", label: "9. Rellena formularios y asiste a entrevistas de selección para buscar trabajo." },
      { var: "dvd_item10", label: "10. Efectúa pago de boletas (agua, luz, internet, etc.) antes de que venza el plazo." },
    ],
  },
];

export function createIcap2Defaults() {
  return {
    dm_item1: 0,
    dm_item2: 0,
    dm_item3: 0,
    dm_item4: 0,
    dm_item5: 0,
    dm_item6: 0,
    dm_item7: 0,
    dsc_item1: 0,
    dsc_item2: 0,
    dsc_item3: 0,
    dsc_item4: 0,
    dsc_item5: 0,
    dvp_item1: 0,
    dvp_item2: 0,
    dvp_item3: 0,
    dvp_item4: 0,
    dvp_item5: 0,
    dvd_item1: 0,
    dvd_item2: 0,
    dvd_item3: 0,
    dvd_item4: 0,
    dvd_item5: 0,
    dvd_item6: 0,
    dvd_item7: 0,
    dvd_item8: 0,
    dvd_item9: 0,
    dvd_item10: 0,
  };
}
